import React, { useState, useEffect } from 'react'
import styles from '../mainBanner/MainBanner.module.scss'
import { Container, Row, Col } from "react-bootstrap";
import parse from 'html-react-parser';
import Loader from "../../loader/Loader";


const MainBanner = (props) => {

  const [loading, setLoading] = useState(false);


  const handleRedirect = () => {
    window.location.href = "/login";
  };

  console.log(props, "props")
  return (
    <>
      {loading && <Loader />}
      <section className={`${styles.bannerMain} bannerMain `} style={{ backgroundColor: props?.pageName == "pricing-v3" ? props.widgetData?.data?.[0]?.card_1_color : props?.widgetData?.data?.banner_color }}>
        <Container className='h-100'>
          <Row className='h-100 ff' >
            <Col xs={12} className="my-auto col-lg-6 col-md-6 text-center  " >

              <img src={props?.widgetData?.data?.[0]?.image} width={472} height={492} className={`${styles.banner__img}  img-fluid `} alt='banner image' />

            </Col>
            <Col xs={12} className="my-auto or1 col-lg-6 col-md-6  ">
              <div className=" ml20">
                <h1 className='mobileHeading ss'>{props?.widgetData?.heading && parse(props?.widgetData?.heading)}</h1>
                <p className={`${styles.mb48} ${styles.para_seha} sehtScanMb0 `}>{props?.widgetData?.description && parse(props?.widgetData?.description)}</p>
                <ul className={styles.listBanner}>
                  {props?.widgetData?.data?.slice(1)?.map((item) => {
                    return (
                      <li>
                        <img src={item?.image}></img>
                        <p>{item?.heading}</p>
                      </li>
                    )
                  }
                  )}
                </ul>
                <button className={styles.signUpBtn} onClick={handleRedirect}>SIGN up NOW!</button>
              </div>
            </Col>
          </Row>
        </Container>
      </section >

    </>
  )
}

export default MainBanner;